import React, { FC, useRef, useState } from 'react'
import { secToHourMinute } from '../../../../../utils/date'

interface TipDetail {
  display: boolean
  service_name: string
  time?: number
}

interface App {
  service_name: string
  use_member_count: number
  use_time: number
}

interface Heatmap {
  type: string
  range: string
  target: string
  id: number
  title: string
  legend: string
  startColor: string
  endColor: string
  minimum: number
  displaySearchLink: boolean
  name: string
}

interface Props {
  target: string
  type: string
  maxValue: number
  apps: App[]
  totalMemberNum: number
  heatmapModalOpenCallback: (heatmap: Heatmap) => void,
}

const MonthlyLegacyGraph: FC<Props> = (props) => {
  const {
    target,
    type,
    maxValue,
    apps,
    totalMemberNum,
    heatmapModalOpenCallback,
  } = props

  const clickLink = (heatmap: Heatmap) => {
    heatmapModalOpenCallback(heatmap)
  }

  const tipRef = useRef() as React.MutableRefObject<HTMLInputElement>
  const graphRef = useRef() as React.MutableRefObject<HTMLInputElement>

  const tipInit:TipDetail = {
    display: false,
    service_name: '',
    time: 0,
  }
  const [tipDetail, setTipDetail] = useState<TipDetail>(tipInit)

  const displayTip = (event: any, service_name: string, time?: number) => {
    if (!tipRef.current) return
    const clientRect = graphRef.current.getBoundingClientRect()
    const x = event.pageX - (clientRect.left + window.pageXOffset)
    const y = event.pageY - (clientRect.top + window.pageYOffset)
    tipRef.current.style.top = `${y - 80}px`
    tipRef.current.style.left = `${x}px`
    setTipDetail({
      ...tipDetail,
      service_name: service_name,
      display: true,
      time: time,
    })
  }

  const hiddenTips = () => {
    if (!tipRef.current) return
    tipRef.current.style.top = "0px"
    tipRef.current.style.left = "0px"
    setTipDetail({
      ...tipDetail,
      display: false,
    })
  }

  const calcValue = (app: App) => ((app.use_time / maxValue) * 100 > 1 ? (app.use_time / maxValue) * 100 : 1)

  return (
    <>
      {
        apps.length ? (
          <>
            <div ref={graphRef}>
              <div className="header_area">
                <div className="header_title">アプリ名</div>
                {
                  target === "team" && (
                    <div className="header_title">作業人数</div>
                  )
                }
                <div
                  style={{
                    minWidth: `calc(100% - ${target === "team" ? "400px" : "200px"})`,
                    textAlign: "center",
                  }}
                >
                  利用時間
                </div>
              </div>
              <div className="detail_area">
                <div
                  className="ruler_area"
                  style={{
                    minWidth: `calc(100% - ${target === "team" ? "400px" : "200px"})`,
                    marginLeft: target === "team" ? "400px" : "200px",
                  }}
                >
                  {
                    [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
                      <div
                        className="ruler"
                        style={{
                          left: `${value}%`,
                        }}
                        key={`files_border_${type}_${value}`}
                      />
                    ))
                  }
                </div>
                {
                  maxValue && apps.filter((app) => app.use_time).map((app) => (
                    <div
                      className="row"
                      key={`files_${type}_${app.service_name}`}
                    >
                      <div className="title_area no_trans">
                        {app.service_name}
                      </div>
                      {
                        target === "team" && (
                          <div
                            className="picture_area legacy"
                            role="none"
                          >
                            <div className="picture_text">
                              {app.use_member_count}
                              &nbsp;/&nbsp;
                              {totalMemberNum}
                              人使用
                            </div>
                          </div>
                        )
                      }
                      <div
                        className="graph_wrap"
                        style={{
                          minWidth: `calc(100% - ${target === "team" ? "400px" : "200px"})`,
                        }}
                      >
                        <div
                          className="graph"
                          style={{
                            width: `${calcValue(app)}%`,
                          }}
                          role="none"
                          onClick={
                            (event) => displayTip(
                              event,
                              app.service_name,
                              app.use_time,
                            )
                          }
                        />
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
            <div
              ref={tipRef}
              className="tip_wrap"
              style={{
                display: tipDetail.display ? "block" : "none",
              }}
            >
              <div className="tip legacy">
                <div className="title no_trans">
                  {tipDetail.service_name}
                </div>
                {
                  tipDetail.time && (
                    <div className="value">
                      作業時間:
                      {secToHourMinute(tipDetail.time)}
                    </div>
                  )
                }
                {
                  tipDetail.service_name && (
                    <button
                      type="button"
                      className="view"
                      onClick={() => clickLink({
                        type: "hour",
                        range: "monthly",
                        target: "team",
                        id: 1,
                        title: "service",
                        legend: `${tipDetail.service_name}`,
                        startColor: "#ecf0f5",
                        endColor: "#008ffb",
                        minimum: 0,
                        name: tipDetail.service_name,
                        displaySearchLink: true,
                      })}
                    >
                      比較データを見る
                    </button>
                  )
                }
                <button
                  type="button"
                  aria-label="close button"
                  className="close"
                  onClick={() => hiddenTips()}
                >
                  ×
                </button>
              </div>
            </div>
            <div
              className="close_legacy_screen"
              style={{
                display: (tipDetail.display) ? "block" : "none",
              }}
              role="none"
              onClick={() => hiddenTips()}
            />
          </>
        ) : (
          <>
            該当するデータはありませんでした
          </>
        )
      }
    </>
  )
}

export default MonthlyLegacyGraph
